export class VistaUpload {
    id!: string
    recordType!: string
    status!: string
    fileName!: string
    rowCount!: number
    batchId?: string
    createdByName?: string
    createdOn!: string
    stagedOn?: string
    completedOn?: string
    errorText?: string
    logText?: string
    failureSummary?: string
    isTerminal!: boolean
    inProgress!: boolean

    // Parsed Date values for grid display/sorting (the API sends ISO strings).
    createdOnDate?: Date
    stagedOnDate?: Date
    completedOnDate?: Date

    protected $setProperties(source: any): void {
        source.createdOnDate = source.createdOn ? new Date(source.createdOn) : null
        source.stagedOnDate = source.stagedOn ? new Date(source.stagedOn) : null
        source.completedOnDate = source.completedOn ? new Date(source.completedOn) : null
    }
}
